import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { VerticalGraph } from "../../components/Charts/VerticalGraph";
import server from "../../environment";

const Holdings = () => {
  const [allHoldings, setAllHoldings] = useState([]);

  useEffect(() => {
    axios
      .get(`${server}/api/user/holdings`, {
        withCredentials: true,
      })
      .then((res) => {
        setAllHoldings(res.data);
      })
      .catch((err) => {
        console.error("Failed to fetch holdings", err);
      });
  }, []);

  const { totalInvestment, currentValue, pnl, pnlPercent } = useMemo(() => {
    let investment = 0;
    let current = 0;

    allHoldings.forEach((stock) => {
      investment += stock.avg * stock.qty;
      current += stock.price * stock.qty;
    });

    const profitLoss = current - investment;
    const percent = investment !== 0 ? (profitLoss / investment) * 100 : 0;

    return {
      totalInvestment: investment,
      currentValue: current,
      pnl: profitLoss,
      pnlPercent: percent,
    };
  }, [allHoldings]);

    const labels = allHoldings.map((subArray) => subArray["name"]);

  const priceData = {
  labels,
  datasets: [
    {
      label: 'Stock Price',
      data: allHoldings.map((stock) => stock.price * stock.qty ),
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
    }
  ],
};

const qtyData = {
  labels,
  datasets: [
    {
      label: 'Stock Quantity',
      data: allHoldings.map((stock) => stock.qty ),
      backgroundColor: 'rgba(99, 167, 255, 0.5)',
    }
  ],
};

   return (
    <>
      <h3 className="title">Holdings ({allHoldings.length})</h3>

      <div className="order-table">
        <table>
          <thead>
            <tr>
              <th>Instrument</th>
              <th>Qty.</th>
              <th>Avg. cost</th>
              <th>LTP</th>
              <th>Cur. val</th>
              <th>P&L</th>
              <th>Net chg.</th>
              <th>Day chg.</th>
            </tr>
          </thead>

          <tbody>
            {allHoldings.map((stock, index) => {
              const curValue = stock.price * stock.qty;
              const pnlValue = curValue - stock.avg * stock.qty;
              const profClass = pnlValue >= 0 ? "profit" : "loss";
              const dayClass = stock.isLoss ? "loss" : "profit";

              return (
                <tr key={stock._id || index}>
                  <td>{stock.name}</td>
                  <td>{stock.qty}</td>
                  <td>{stock.avg.toFixed(2)}</td>
                  <td>{stock.price.toFixed(2)}</td>
                  <td>{curValue.toFixed(2)}</td>
                  <td className={profClass}>{pnlValue.toFixed(2)}</td>
                  <td className={profClass}>{stock.net}</td>
                  <td className={dayClass}>{stock.day}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>


      <div className="row">
        <div className="col">
          <h5>
            {totalInvestment.toFixed(2)}
          </h5>
          <p>Total investment</p>
        </div>

        <div className="col">
          <h5>
            {currentValue.toFixed(2)}
          </h5>
          <p>Current value</p>
        </div>

        <div className="col">
          <h5 className={pnl >= 0 ? "profit" : "loss"}>
            {pnl.toFixed(2)} ({pnlPercent.toFixed(2)}%)
          </h5>
          <p>P&amp;L</p>
        </div>
      </div>


      {allHoldings.length > 0 && <VerticalGraph data={priceData}/>}
      <br></br>
      {allHoldings.length > 0 && <VerticalGraph data={qtyData}/>}
    </>
  );
};

export default Holdings;
